import React, { /* memo, */ forwardRef } from 'react';
import styled from 'styled-components';
import { propStyles } from '../styleHelper';
import styleFilter from '../styleFilter';

const StyledInput = styled(styleFilter(styled.input``))`
  box-sizing: border-box;
  height: 48px;
  width: 100%;
  padding-left: ${props => props.theme.padding.normal};
  padding-right: ${props => props.theme.padding.normal};
  font-size: ${props => props.theme.fontSize.medium};
  color: ${props => props.theme.text.normal};
  border-style: solid;
  border-width: 1px;
  border-color: ${props => props.theme.border.border500};
  border-radius: 4px;
  white-space: nowrap;
  outline: none;
  transition: all 0.3s ease;
  font-family: ${props => props.theme.font.circular};
  &::placeholder {
    color: ${props => props.theme.text.text200};
  }
  &:placeholder-shown {
    border-color: ${props => props.theme.border.border400};
  }
  &:hover:not([readonly]),
  &:focus:not([readonly]) {
    outline: none;
    border-color: ${props => props.theme.border.border700};
  }
  &[readonly] {
    cursor: not-allowed;
    background: ${props => props.theme.background.background200};
    color: ${props => props.theme.text.text300};
    border-color: ${props => props.theme.border.border400};
  }
  ${propStyles}
`;

/*
const Input = memo(
  props => <StyledInput {...props} />,
  (prevProps, nextProps) => prevProps.value === nextProps.value
);
*/

const Input = forwardRef((props, ref) => {
  return <StyledInput ref={ref} {...props} />;
});

Input.defaultProps = {
  type: 'text',
  placeholder: ' ',
};

export default Input;
